import { ICON_BASE_PATH } from "@/app/utils/config";

interface SuccessMessageProps {
  message: string | null | undefined;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="gx-pop-message">
<div className="gx-success-update-message">
      <img src={`${ICON_BASE_PATH}successfully.png`} alt="requiredicon" />
      <p className="gx-p14-md">{message}</p>
    </div>
    </div>
    
  );
};

export default SuccessMessage;
